import moment from 'moment';
import api from './api';

const selectBase = (base) => {
	return {
		...base,
		createdAt: base.createdAt ? moment(base.createdAt).toDate() : null,
		updatedAt: base.updatedAt ? moment(base.updatedAt).toDate() : null,
	};
};

const selectBases = (bases) => bases.map(selectBase);

class BaseService {
	async getAll({ page = 0, size = 10 }) {
		return api
			.get('/bases', {
				params: {
					page,
					size,
				},
			})
			.then((response) => response.data)
			.then((data) => ({ ...data, body: selectBases(data.body) }))
			.catch((error) => {
				console.log(
					'fail when trying to get clients in ClientService.',
					error.response?.data?.error,
				);
				throw error.response?.data?.error;
			});
	}

	async get(id) {
		return api
			.get(`/bases/${id}`)
			.then((response) => response.data)
			.then((data) => data.body)
			.then(selectBase)
			.catch((error) => {
				console.log('fail when trying to get base in BaseService.', error.response?.data?.error);
				throw error.response?.data?.error;
			});
	}

	async getOrdersVaiFacil(id) {
		return api
			.get(`/bases/${id}/orders-vai-facil`)
			.then((response) => response.data)
			.then((data) => data.body)
			.catch((error) => {
				console.log(
					'fail when trying to get orders vai facil in BaseService.',
					error.response?.data?.error,
				);
				throw error.response?.data?.error;
			});
	}

	async dispatchOrdersVaiFacil(id, delivermanId, trackingCodes) {
		return api
			.post(`/bases/${id}/dispatch-orders-vai-facil`, { trackingCodes, delivermanId })
			.then((response) => response.data)
			.then((data) => data.body)
			.catch((error) => {
				console.log(
					'fail when trying to dispatch orders vai facil in BaseService.',
					error.response?.data?.error,
				);
				throw error.response?.data?.error;
			});
	}

	async remove(id) {
		return api
			.delete(`/bases/${id}`)
			.then((response) => response.data)
			.then((data) => data.body)
			.catch((error) => {
				console.log('fail when trying to remove base in BaseService.', error.response?.data?.error);
				throw error.response?.data?.error;
			});
	}

	async create(baseForm) {
		return api
			.post('/bases', baseForm)
			.then((response) => response.data)
			.then((data) => data.body)
			.then(selectBase)
			.catch((error) => {
				console.log('fail when trying to create base in BaseService.', error.response?.data?.error);
				throw error.response?.data?.error;
			});
	}

	async update(id, baseForm) {
		return api
			.patch(`/bases/${id}`, baseForm)
			.then((response) => response.data)
			.then((data) => data.body)
			.then(selectBase)
			.catch((error) => {
				console.log('fail when trying to update base in BaseService.', error.response?.data?.error);
				throw error.response?.data?.error;
			});
	}

	async getZones(baseId) {
		return api
			.get(`/bases/${baseId}/zones`)
			.then((response) => response.data)
			.then((data) => data.body)
			.catch((error) => {
				console.log('fail when trying to get zones in BaseService.', error.response?.data?.error);
				throw error.response?.data?.error;
			});
	}
}

const baseService = new BaseService();
export default baseService;
